var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('h4',[_vm._v("Oops!")]),_vm._v(" "),_c('p',[_vm._v("Page not found")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Go back to home")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d032df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
// module id = null
// module chunks = 